const DEFAULT_TITLE_MAX_WIDTH = 520;
const DEFAULT_TITLE_GUTTER = 24;
const DEFAULT_MIN_VISIBLE_WIDTH = 160;

interface ApplicationBarTitleLayoutInput {
  gapStart: number;
  gapEnd: number;
}

interface ApplicationBarTitleLayoutResult {
  shouldShowTitle: boolean;
  titleCenterX: number;
  titleMaxWidth: number;
}

export const getApplicationBarTitleLayout = ({
  gapStart,
  gapEnd,
}: ApplicationBarTitleLayoutInput): ApplicationBarTitleLayoutResult => {
  const safeGapStart = Math.max(gapStart, 0);
  const safeGapEnd = Math.max(gapEnd, safeGapStart);
  const gapWidth = Math.max(safeGapEnd - safeGapStart, 0);
  const titleCenterX = safeGapStart + gapWidth / 2;
  const titleMaxWidth = Math.max(gapWidth - DEFAULT_TITLE_GUTTER * 2, 0);

  return {
    shouldShowTitle: titleMaxWidth >= DEFAULT_MIN_VISIBLE_WIDTH,
    titleCenterX,
    titleMaxWidth: Math.min(titleMaxWidth, DEFAULT_TITLE_MAX_WIDTH),
  };
};
